<div class="gs-wrapper" #searchWrapper [class.gs-expanded]="isExpanded()">

  <!-- ── Search bar ── -->
  <div class="gs-bar" [class.gs-bar--active]="hasActiveFilter()">
    <i class="pi pi-search gs-icon-search"></i>

    <input
      id="global-search-input"
      class="gs-input"
      type="text"
      placeholder="Search dashboard..."
      [value]="searchQuery()"
      (input)="onInputChange($any($event.target).value)"
      (focus)="onFocus()"
      autocomplete="off"
    />

    <!-- Loading spinner while API call is in flight -->
    @if (apiLoading()) {
      <i class="pi pi-spin pi-spinner gs-icon-spinner"></i>
    }

    <!-- Clear button -->
    @if (searchQuery() || hasActiveFilter()) {
      <button
        class="gs-btn-clear"
        type="button"
        title="Clear search"
        (click)="clearSearch()"
      >
        <i class="pi pi-times"></i>
      </button>
    }
  </div>

  <!-- ── Suggestions dropdown ── -->
  @if (showDropdown() && (hasAnyResult() || apiLoading())) {
    <div class="gs-dropdown" role="listbox" aria-label="Search suggestions">

      <!-- ── Section: Navigation (local) ── -->
      @if (filteredSuggestions().length > 0) {
        <div class="gs-section-header">
          <i class="pi pi-compass"></i>
          <span>Navigation</span>
        </div>
        @for (item of filteredSuggestions(); track item.id) {
          <div
            class="gs-item"
            role="option"
            [attr.aria-selected]="selectedItem()?.id === item.id"
            (mousedown)="selectSuggestion(item)"
          >
            <div class="gs-item-top">
              <i class="pi pi-th-large gs-item-icon"></i>
              <span class="gs-item-title">{{ item.title }}</span>
            </div>
            <span class="gs-item-route">{{ item.routeLabel }}</span>
          </div>
        }
      }

      <!-- ── Section: Quotes (API) ── -->
      @if (apiQuotes().length > 0) {
        <div class="gs-section-header">
          <i class="pi pi-file"></i>
          <span>Quotes</span>
        </div>
        @for (quote of apiQuotes(); track quote.id) {
          <div
            class="gs-item gs-item--api"
            role="option"
            (mousedown)="selectApiQuote(quote)"
          >
            <div class="gs-item-top">
              <i class="pi pi-file-edit gs-item-icon"></i>
              <span class="gs-item-title gs-item-title--truncate">{{ quote.project_name }}</span>
              <span class="gs-status-badge" [ngClass]="getStatusClass(quote.status)">
                {{ getStatusLabel(quote.status) }}
              </span>
            </div>
            <span class="gs-item-route">{{ quote.client_name }} · {{ quote.target_country }}</span>
          </div>
        }
      }

      <!-- ── Section: Users (API) ── -->
      @if (apiUsers().length > 0 && getRole() === "admin") {
        <div class="gs-section-header">
          <i class="pi pi-users"></i>
          <span>Users</span>
        </div>
        @for (user of apiUsers(); track user.id) {
          <div
            class="gs-item gs-item--api"
            role="option"
            (mousedown)="selectApiUser(user)"
          >
            <div class="gs-item-top">
              <i class="pi pi-user gs-item-icon"></i>
              <span class="gs-item-title">{{ user.username }}</span>
              <span class="gs-role-badge">{{ user.role_display }}</span>
            </div>
            <span class="gs-item-route">{{ user.email }}</span>
          </div>
        }
      }

    </div>
  }

  <!-- ── No results ── -->
  @if (showDropdown() && !hasAnyResult() && !apiLoading() && searchQuery().trim().length > 1) {
    <div class="gs-dropdown gs-dropdown--empty">
      <span class="gs-empty-msg">
        <i class="pi pi-info-circle"></i>
        No results for "<strong>{{ searchQuery() }}</strong>"
      </span>
    </div>
  }

</div>